module.exports = __webpack_public_path__ + "static/logo_white_letter_vertical_512.344ee9dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/logo_white_letter_vertical_512.png
// module id = 694
// module chunks = 19843951674672